import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const inviteKeys = {
  all: ["invites"],
  lists: () => [...inviteKeys.all, "list"],
  list: (filters) => [...inviteKeys.lists(), { filters }],
  items: () => [...inviteKeys.all, "item"],
  item: (id) => [...inviteKeys.items(), id],
};

export function useInvite(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: inviteKeys.item(args.id),
    queryFn: () => func(args.id),
    ...queryOptions,
  });
}

export function useInvites(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: inviteKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

export function useUpdateInvite(func) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (data, context) => {
      queryClient.setQueryData(inviteKeys.item(data.Item.id), {
        ...context?.prevState,
        ...data.Item,
      });
    },
  });
}

export function useCreateInvite(func) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (data) => {
      return data;
    },
  });
}

export function useDeleteInvite(func) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: () => {},
  });
}
